/** Values sent to / displayed from API; labels use standard WMS terms */
export const APPOINTMENT_TYPE_OPTIONS = [
    { value: "Inbound", label: "Inbound" },
    { value: "Outbound", label: "Outbound" },
];

/**
 * Create payload: header field `appointmenttype` must be numeric 0 or 1.
 * 0 = Inbound, 1 = Outbound.
 */
export const APPOINTMENT_TYPE_API_VALUE = {
    Inbound: 0,
    Outbound: 1,
};

export function appointmentTypeLabelToApiValue(label) {
    if (label === "Outbound") return APPOINTMENT_TYPE_API_VALUE.Outbound;
    return APPOINTMENT_TYPE_API_VALUE.Inbound;
}

/** Map API `appointmenttype` / `AppointmentType` to Inbound | Outbound for UI. */
export function normalizeAppointmentTypeFromApi(t) {
    if (t === 0 || t === "0") return "Inbound";
    if (t === 1 || t === "1") return "Outbound";
    const s = String(t ?? "")
        .trim()
        .toLowerCase();
    if (s === "inbound" || s === "inbond") return "Inbound";
    if (s === "outbound" || s === "outbond") return "Outbound";
    return t ?? "";
}

/** Optional on create; values sent as `TrailerType` on the appointment header. */
export const TRAILER_TYPE_OPTIONS = [
    { value: "Pallet", label: "Pallet" },
    { value: "Trailer", label: "Trailer" },
];

/**
 * `sourcetype` on each `appointmentdetails[]` row must match header `appointmenttype`
 * (same 0 / 1): 0 = Inbound (ASN `sourcekey`), 1 = Outbound (sales order `sourcekey`).
 *
 * Create payload: `appointmentdetails: [{ sourcekey, sourcetype, insert }]`.
 */

export const appointmentHeaderFields = [
    { name: "Warehouse", label: "Warehouse" },
    { name: "AppointmentKey", label: "Appointment Key" },
    {
        name: "AppointmentType",
        label: "Appointment Type",
        type: "select",
        options: APPOINTMENT_TYPE_OPTIONS,
    },
    { name: "Status", label: "Status" },
    { name: "Door", label: "Door" },
    { name: "Carrier", label: "Carrier" },
    { name: "Trailer", label: "Trailer" },
    { name: "TrailerType", label: "Trailer Type" },
    { name: "GMTStartDateAndTime", label: "Start (GMT)" },
    { name: "GMTEndDateAndTime", label: "End (GMT)" },
    { name: "Owner", label: "Owner" },
    { name: "CustomerVendor", label: "Customer / Vendor" },
    { name: "AddDate", label: "Add Date" },
    { name: "addwho", label: "Added By" },
    { name: "editwho", label: "Edited By" },
    { name: "editdate", label: "Edit Date", type: "text", readOnly: true },
];

/** Inbound appointment: ASN / receipt lines */
export const asnDetailColumns = [
    { field: "lineNo", headerName: "Line#", width: 70, sortable: false },
    { field: "AppointmentKey", headerName: "Appointment Key", width: 140, sortable: false },
    { field: "ReceiptKey", headerName: "Receipt Key", width: 130, sortable: false },
    { field: "ExternReceiptKey", headerName: "Extern Receipt Key", width: 160, sortable: false },
    { field: "Status", headerName: "Status", width: 90, sortable: false },
    { field: "StorerKey", headerName: "Storer", width: 120, sortable: false },
    { field: "CarrierKey", headerName: "Carrier", width: 120, sortable: false },
    { field: "ExpectedReceiptDate", headerName: "Expected Receipt Date", width: 180, sortable: false },
];

/** Outbound / non-inbound: order lines */
export const orderDetailColumns = [
    { field: "lineNo", headerName: "Line#", width: 70, sortable: false },
    { field: "AppointmentKey", headerName: "Appointment Key", width: 140, sortable: false },
    { field: "OrderKey", headerName: "Order Key", width: 130, sortable: false },
    { field: "ExternOrderKey", headerName: "Extern Order Key", width: 160, sortable: false },
    { field: "Status", headerName: "Status", width: 90, sortable: false },
    { field: "StorerKey", headerName: "Storer", width: 120, sortable: false },
    { field: "CarrierKey", headerName: "Carrier", width: 120, sortable: false },
    { field: "OrderDate", headerName: "Order Date", width: 160, sortable: false },
];
